export const SET_USER_TYPING = "SET_USER_TYPING";

export const setUserTyping = (matchId, userId, isTyping) => ({
  type: SET_USER_TYPING,
  payload: { matchId, userId, isTyping }
});
